import { Button } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const PracticesBtn = () => {
  return (
    <Button
      fullWidth={(isMobile || window.innerWidth <= 785) && true}
      onClick={() => (window.location.href = "/area_controller/pratiche")}
      sx={{ color: !isMobile && "white", borderBottom: isMobile && "1px solid #ddd", mb: isMobile && 1 }}
    >
      PRATICHE
    </Button>
  );
};

export default PracticesBtn;